import type { Lead, SkillTag } from "../client";

export function getLeadSkillNames(lead?: Lead): string[] {
  if (lead?.parsedAssignmentData) {
    const { technical_required, technical_optional } = lead.parsedAssignmentData.skills;
    return [...technical_required, ...technical_optional];
  }
  return lead?.assignmentInfo?.skillTags?.map((sk) => sk.name) ?? [];
}

export function getLeadSkillTags(lead?: Lead): SkillTag[] {
  if (lead?.parsedAssignmentData) {
    const { technical_required, technical_optional } = lead.parsedAssignmentData.skills;
    return [...technical_required, ...technical_optional].map((name) => ({
      name,
      customIconName: "",
    }));
  }
  return lead?.assignmentInfo?.skillTags ?? [];
}

export function getLeadIndustry(lead?: Lead): string {
  return lead?.parsedAssignmentData?.industry ?? lead?.assignmentInfo?.sector ?? "";
}

export function hasAssignmentData(lead?: Lead): boolean {
  if (lead?.parsedAssignmentData) return true;
  return !!(lead?.assignmentInfo?.skillTags && lead.assignmentInfo.skillTags.length > 0);
}
